import { Button, Col, Row, Select, Tag } from 'antd'
import React, { useState } from 'react'
import { t } from 'i18next'
import { PlusOutlined, MinusOutlined } from '@ant-design/icons'
import { displayCommunication, ROLES } from '../../Common/Common'
import { Link } from 'react-router-dom'
import { Color } from '../../Common/Color'

const TERRITORY_ROLE = 'territory_responsable'
const isTerritoryResponsable = (i) => i.role === TERRITORY_ROLE
const sortInterveners = (list) => [...list].sort((a, b) => isTerritoryResponsable(b) - isTerritoryResponsable(a))

export default function BoxIntervenersTab ({ form, interveners }) {
  const [displayedInterveners, setDisplayedInterveners] = useState(sortInterveners(form.getFieldValue('interveners') || []))
  const [intervener, setIntervener] = useState()
  const [role, setRole] = useState()

  const updateInterveners = (iArray) => {
    const sorted = sortInterveners(iArray)
    setDisplayedInterveners(sorted)
    form.setFieldValue('interveners', sorted)
  }

  const addIntervener = () => {
    const addedIntervener = interveners.find(i => i.id === intervener)
    updateInterveners([...displayedInterveners, addedIntervener])
    setIntervener(null)
  }

  const removeIntervener = (i) => {
    updateInterveners(displayedInterveners.filter(intervener => intervener.id !== i.id))
  }

  const rowStyle = (i) => {
    const style = { flexFlow: 'row', padding: '0.5em 0' }
    if (isTerritoryResponsable(i)) {
      return { ...style, fontWeight: 'bold', backgroundColor: Color.light_orange, borderLeft: `4px solid ${Color.dark_orange}` }
    }
    return i.internal ? { ...style, fontWeight: 'bold' } : style
  }

  const displayInterveners = () => {
    return (
      displayedInterveners.map(i => (
        <Row key={i.id} data-testid={`intervener-${i.id}`} style={rowStyle(i)}>
          <Col span={3} style={{ marginRight: 'auto', textAlign: 'center' }}>
            {t(`Admin.Intervener.attributes.role.${i.role}`)}
          </Col>
          <Col span={3} style={{ marginRight: 'auto', textAlign: 'center' }}>
            {i.job}
          </Col>
          <Col span={3} style={{ marginRight: 'auto', textAlign: 'center' }}>
            <Link to={`/admin/interveners/${i.id}`} style={{ color: 'black', textDecoration: 'underline' }}>{i.name}</Link>
          </Col>
          <Col span={3} style={{
            marginRight: 'auto',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'space-evenly',
            alignContent: 'center',
            flexWrap: 'balance'
          }}>
            {i.tags.map(tag => <Tag key={`${i.id}-${tag}`} color={t(`Admin.Intervener.attributes.tagsColor.${tag}`)} variant='outlined'>
                {t(`Admin.Intervener.attributes.tags.${tag}`)}
              </Tag>)
            }
          </Col>
          <Col span={3} style={{ marginRight: 'auto', textAlign: 'center' }}>
            {i.description}
          </Col>
          {displayCommunicationMeans(i.phones, i.emails)}
          <Button onClick={() => removeIntervener(i)} type="primary" style={{ marginLeft: 'auto' }} shape="circle" icon={<MinusOutlined />} />
        </Row>
      ))
    )
  }

  const displayCommunicationMeans = (phones, emails) => {
    return (
      <>
        <Col span={2} style={{ marginRight: 'auto', textAlign: 'center' }}>
          {phones.map(phone => displayCommunication(phone))}
        </Col>
        <Col span={4} style={{ marginRight: 'auto', textAlign: 'center' }}>
          {emails.map(email => displayCommunication(email))}
        </Col>
      </>
    )
  }

  const filteredInterveners = (interveners, role, displayedInterveners) => {
    if (role) {
      return interveners?.filter(i => i.role === role && !displayedInterveners.map(e => e.id).includes(i.id))
    } else {
      return interveners?.filter(i => !displayedInterveners.map(e => e.id).includes(i.id))
    }
  }

  return (
    <div>
      <Row style={{ marginBottom: '2em' }}>
        <Select
          showSearch={{
            optionFilterProp: 'children',
            filterOption: (input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }}
          allowClear
          placeholder="Filtrer par fonction"
          options={ROLES.map((o) => ({ label: t(`Admin.Intervener.attributes.role.${o}`), value: o }))}
          onSelect={(value) => setRole(value)}
          onClear={() => setRole(null)}
          value={role}
          style={{ width: '18em' }}
        />
        <Select
          showSearch={{
            optionFilterProp: 'children',
            filterOption: (input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }}
          placeholder="Rechercher un intervenant"
          options={filteredInterveners(interveners, role, displayedInterveners).map((o) => ({ label: o.name, value: o.id }))}
          onSelect={(value) => setIntervener(value)}
          value={intervener}
          style={{ width: '23em' }}
        />
        <Button disabled={!intervener} onClick={addIntervener} type="primary" style={{ marginLeft: '2em' }} shape="circle" icon={<PlusOutlined />} />
      </Row>
      {displayInterveners()}
    </div>
  )
}
